<template>
  <div
    class="overflow-y-hidden rounded-xl h-full flex flex-col w-full"
    :style="`--offset-height:64px`"
  >
    <Transition>
      <!-- PAGE -->
      <div
        class="h-full w-full pointer-events-auto overflow-y-auto rounded-xl relative overflow-x-hidden flex flex-col-reverse bg-gray-1"
      >
        <!-- TABS / NAV BAR -->
        <Tabs v-if="loggedIn" />

        <!-- INNER VIEW -->
        <slot></slot>
      </div>
    </Transition>
  </div>
</template>

<script setup lang="ts">
import Tabs from './Tabs.vue';
import type { Pinia } from 'pinia';
import { inject } from 'vue';
import { useAdminStore } from '@getmayday/vue-modules';

const pinia = inject('pinia') as Pinia;

const adminStore = useAdminStore(pinia);
const { loggedIn } = storeToRefs(adminStore);

const emit = defineEmits(['expand-copilot']);


// THIS PART IS NEEDED BECAUSE OF THE ROUTER TRANSITION
const route = useRoute();
const disabledTransition = ref(false);
watch(
  () => route.fullPath,
  () => {
    disabledTransition.value = true;
    setTimeout(() => {
      disabledTransition.value = false;
    }, 500);
  },
);
</script>
